var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "margin mb-20", attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 12 } },
            [
              _c("app-label", { attrs: { label: "Estado", required: true } }),
              _c(
                "el-select",
                {
                  staticClass: "full-width",
                  attrs: { placeholder: "Selecione o estado" },
                  on: { change: _vm.changeEstado },
                  model: {
                    value: _vm.informacaoLocalizacao.estado,
                    callback: function($$v) {
                      _vm.$set(_vm.informacaoLocalizacao, "estado", $$v)
                    },
                    expression: "informacaoLocalizacao.estado"
                  }
                },
                _vm._l(_vm.estadosBr, function(estado) {
                  return _c("el-option", {
                    key: estado.codigo,
                    attrs: { label: estado.nome, value: estado.codigo }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm.informacaoLocalizacao.municipio &&
          _vm.informacaoLocalizacao.municipio !== ""
            ? _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 12 } },
                [
                  _c("app-label", {
                    attrs: { label: "Município", required: true }
                  }),
                  _c(
                    "el-select",
                    {
                      staticClass: "full-width",
                      attrs: { placeholder: "Selecione o município" },
                      on: { change: _vm.changeMunicipio },
                      model: {
                        value: _vm.idSelecionado,
                        callback: function($$v) {
                          _vm.idSelecionado = $$v
                        },
                        expression: "idSelecionado"
                      }
                    },
                    _vm._l(_vm.municipios, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.nome, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "margin mb-20", attrs: { gutter: 20 } },
        [
          _c("validation-provider", {
            staticClass: "mt-20",
            attrs: { name: "Georreferenciamento/Geometria" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("mapa-analise-geomensor", {
                      attrs: {
                        localizacoes: _vm.informacaoLocalizacao.geometrias,
                        tipoCadastro: "UC",
                        name: "Geometria",
                        idMapa: "mapaAnaliseGeomensor",
                        errors: errors,
                        addOrtoFotos: true
                      },
                      on: {
                        shapefileUploaded: _vm.setShapefile,
                        shapefileRemoved: _vm.removeShapefile
                      },
                      model: {
                        value: _vm.informacaoLocalizacao.geometrias,
                        callback: function($$v) {
                          _vm.$set(_vm.informacaoLocalizacao, "geometrias", $$v)
                        },
                        expression: "informacaoLocalizacao.geometrias"
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dcda3396", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcda3396","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/AppFormularioLocalizacao.vue
// module id = null
// module chunks = 